import { Store } from '../configureStore';

// Used until the slug API response has loaded, or when it doesn't carry
// uiFeatureFlags.isOfflineEnabled at all.
const DEFAULT_USE_NEW_ORDER_API = false;

// Drives whether order-related calls go through the new offline order
// endpoints. Backed by uiFeatureFlags.isOfflineEnabled from the
// /api/customers/locations/slug response (restaurant.currentRestaurantDetail
// in the store), not a hardcoded value.
export const isUseNewOrderApiEnabled = (): boolean => {
  const state = Store.getState() as any;
  if (state?.restaurant?.restaurantDetailLoading) {
    return DEFAULT_USE_NEW_ORDER_API;
  }
  const flag = state?.restaurant?.currentRestaurantDetail?.uiFeatureFlags?.isOfflineEnabled;
  return typeof flag === 'boolean' ? flag : DEFAULT_USE_NEW_ORDER_API;
};

/** True once the slug API has answered and carried uiFeatureFlags.isOfflineEnabled. */
export const isOfflineFlagKnown = (): boolean => {
  const state = Store.getState() as any;
  if (state?.restaurant?.restaurantDetailLoading) return false;
  return typeof state?.restaurant?.currentRestaurantDetail?.uiFeatureFlags?.isOfflineEnabled === 'boolean';
};

const OFFLINE_API_CONFIGURED = Boolean(process.env.REACT_APP_OFFLINE_API_ENDPOINT);

/**
 * Receipt links. The receipt page loads the location first when the link carries its slug, so the
 * flag is known and decides as everywhere else. An older link without a slug gives the page no
 * location to load: then, on a build that has the offline API, ask the offline API (with the
 * decrypted order id). It serves offline orders and itself falls back to the legacy mh_orders
 * table, and the saga falls back to the legacy API if that call fails.
 */
export const shouldUseNewOrderApiForReceipt = (): boolean =>
  isOfflineFlagKnown() ? isUseNewOrderApiEnabled() : OFFLINE_API_CONFIGURED;
